import { createActionConst } from '../../utils/action.utils';

const TASK_MODAL_NAMESPACE = 'TASK_MODAL_NAMESPACE';

export const STORE_TASK_MODAL_STATUS = createActionConst(TASK_MODAL_NAMESPACE, 'STORE_TASK_MODAL_STATUS');
export const CLEAR_TASK_MODAL_STATUS = createActionConst(TASK_MODAL_NAMESPACE, 'CLEAR_TASK_MODAL_STATUS');
export const CLEAR_TASK_MODAL_STATUSES = createActionConst(TASK_MODAL_NAMESPACE, 'CLEAR_TASK_MODAL_STATUSES');
